// UI font preference for Apple TV clone surfaces.
//
// "system" — SF / system UI stack
// "gaegu"  — Gaegu display font (Google Fonts)
//
// Persisted in localStorage and applied as a class on <body>.

// v2: product default switched from Gaegu → system; new key ignores old saves.
const STORAGE_KEY = "curator:appleFont:v2";
const BODY_CLASS_GAEGU = "apple-font-gaegu";
const BODY_CLASS_SYSTEM = "apple-font-system";

export const APPLE_FONT_SYSTEM = "system";
export const APPLE_FONT_GAEGU = "gaegu";

export const APPLE_FONTS = [
  {
    id: APPLE_FONT_SYSTEM,
    name: "Digital",
    description: "SF Pro and system UI fonts.",
  },
  {
    id: APPLE_FONT_GAEGU,
    name: "Handwritten",
    description: "Rounded handwritten display font.",
  },
];

export function getStoredAppleFont() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (value === APPLE_FONT_SYSTEM) return APPLE_FONT_SYSTEM;
    if (value === APPLE_FONT_GAEGU) return APPLE_FONT_GAEGU;
    // Default to system UI fonts when no preference is stored.
    return APPLE_FONT_SYSTEM;
  } catch (_err) {
    return APPLE_FONT_SYSTEM;
  }
}

export function applyAppleFont(font) {
  if (typeof document === "undefined") return;
  const useGaegu = font === APPLE_FONT_GAEGU;
  document.body.classList.toggle(BODY_CLASS_GAEGU, useGaegu);
  document.body.classList.toggle(BODY_CLASS_SYSTEM, !useGaegu);
}

export function clearAppleFontClass() {
  if (typeof document === "undefined") return;
  document.body.classList.remove(BODY_CLASS_GAEGU, BODY_CLASS_SYSTEM);
}

export function setAppleFont(font) {
  const next = font === APPLE_FONT_SYSTEM ? APPLE_FONT_SYSTEM : APPLE_FONT_GAEGU;
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch (_err) {
    // Storage unavailable; still apply for the session.
  }
  applyAppleFont(next);
  return next;
}
